import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import { useState, useEffect, useRef } from "react";
import { BaseUrl } from "../../helper/BaseUrl";
import axios from "axios";

const getCategories = (blogs) => [
  "All",
  ...new Set((blogs || []).map((b) => b.category_name).filter(Boolean)),
];


const truncateWords = (text, limit) => {
  if (!text) return "";
  const words = text.split(" ");
  return words.length > limit
    ? words.slice(0, limit).join(" ") + "..."
    : text;
};

export default function BlogCard({ initialBlogs = [] }) {
  const [categories, setCategories] = useState(getCategories(initialBlogs));
  const [selected, setSelected] = useState("All"); 

  const [open, setOpen] = useState(false);
  const filterRef = useRef(null);

  const [allData, setAllData] = useState(initialBlogs);
  const [visibleCount, setVisibleCount] = useState(6);
  const [isLoadMore, setIsLoadMore] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  // close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (filterRef.current && !filterRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // close on Esc key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keyup", handleEsc);
    return () => document.removeEventListener("keyup", handleEsc);
  }, []);

  const handleSelect = (name) => {
    setSelected(name);
    setOpen(false);
  };

  const handleSearch = (e) => setSearchQuery(e.target.value.toLowerCase());

  useEffect(() => {
    if (initialBlogs.length > 0) {
      return;
    }

    const fetchData = async () => {
      try {
        const response = await axios.get(`${BaseUrl}/api/blog`);
        const blogs = Array.isArray(response.data.data)
          ? response.data.data
          : [];
        setAllData(blogs);

        setCategories(getCategories(blogs));
      } catch (error) {
        console.error("Data fetch error:", error);
        setAllData([]);
        setCategories(["All"]);
      }
    };
    fetchData();
  }, [initialBlogs.length]);



  const filteredData = (allData || []).filter((card) => {
    const matchSearch = String(card.title || "")
      .toLowerCase()
      .includes(searchQuery);
    const matchCategory =
      selected && selected !== "All"
        ? card.category_name === selected
        : true;
    return matchSearch && matchCategory;
  });

  const convertDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString; // fallback if not a date
    const months = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month} ${day}, ${year}`;
  };

  const handleLoadMore = () => {
    if (isLoadMore) {
      setVisibleCount((prev) => {
        const next = Math.min(prev + 3, allData.length);
        if (next >= allData.length) setIsLoadMore(false);
        return next;
      });
    } else {
      setVisibleCount(6);
      setIsLoadMore(true);
    }
  };


  return (
    <>
      <div className="blogpage-filter">
        <div className="container">
          <div className="row">

            <div className="col-lg-12">
              <div className="filter-blogbar">
                <div className="blogsearch">
                  <input value={searchQuery} onChange={handleSearch} type="text" name="search" placeholder="Search here" className="form-control" />
                  <Link className="default-btn colored-btn"><Icons name="search" /> Search</Link>
                </div>

                <div className="seachdivider"></div>

                <div className={`bloglist-filter ${open ? "open" : ""}`} ref={filterRef}>
                    <div className="caption-filter" onClick={() => setOpen((prev) => !prev)}>
                      {selected || "Filter"}
                    </div>
                    <Icons name="arrowDown"/>
                    <div className="list">
                    {categories.map((name, index) => (
                      <div key={index} className={`item ${selected === name ? "selected" : ""}`}
                        onClick={() => handleSelect(name)}>
                        {name}
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </div>

            {filteredData.slice(0, visibleCount).map((card, index) => (
            <div className="col-lg-4 col-sm-6 col-md-6" key={index}>
              <div className="bloglist-box">
                <Link to={`/blog/${card.slug}`}>
                  <img src={`${BaseUrl}${card.thumbnail}`} loading="lazy" className="img-responsive" alt="Blog"/>
                  <div className="bloglist-admin">
                      <img src={`${BaseUrl}${card.author_image}`} alt="admin" loading="lazy"/>
                      <small>Written by {card.author_name}</small>
                  </div>
                  <p>{truncateWords(card.title, 10)}</p>
                  <div className="bloglist-date">
                      <label>{convertDate(card.created_at)}</label>
                      <span><Icons name="Longarrow_right"/></span>
                  </div>
                </Link>
              </div>
            </div>
            ))}

            {!searchQuery && (
            <div className="col-lg-12 text-center">
                <Link onClick={handleLoadMore} className="default-btn colored-btn">{isLoadMore ? "Load More" : "Load Less"} <Icons name="Longarrow_right"/></Link>
            </div>
            )}

          </div>
        </div>
      </div>
    </>
  )
}
